import { render, staticRenderFns } from "./SidebarContentColumn.vue?vue&type=template&id=48c12c8a&scoped=true"
import script from "./SidebarContentColumn.vue?vue&type=script&lang=js"
export * from "./SidebarContentColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c12c8a",
  null
  
)

export default component.exports